// extracted by mini-css-extract-plugin
export default {"box":"iGGKU9sD1TL1aBx72Bty"};